import React, { useContext, useEffect,} from "react";
import { AdminContext } from "context/AdminContext";
import { useDispatch } from "react-redux";
import { emptySetting } from "redux/Actions/SettingActions";
import { emptySideBarMenu } from "redux/Actions/SideBarActions";

const InactivityHandler = ({ children }) => {
    const {  dispatch } = useContext(AdminContext);
     const reduxDisPatch = useDispatch();
  const inactivityLimit = 60 *60 * 1000; // 60 minutes
  const activityKey = "lastActivity"; // Key in localStorage

  const handleLogOut = () => {
      dispatch({ type: "USER_LOGOUT" });
      localStorage.removeItem("adminInfo");
      localStorage.removeItem("authTime")
      localStorage.removeItem(activityKey);
      reduxDisPatch(emptySideBarMenu());
      reduxDisPatch(emptySetting());
      // window.location.replace(`http://localhost:4009/login`);
    };
  const updateActivity = () => {
    const timestamp = Date.now();
    localStorage.setItem(activityKey, timestamp.toString());
  };

  const checkInactivity = () => {
    const lastActivity = localStorage.getItem(activityKey);
    const now = Date.now();

    if (lastActivity && now - parseInt(lastActivity) > inactivityLimit) {
      localStorage.removeItem(activityKey);
      handleLogOut();
    }
  };

  const resetTimer = () => {
    updateActivity(); // Update activity on interaction
  };

  useEffect(() => {
    const events = ["mousemove", "click", "keydown", "scroll"];

    // Set initial activity timestamp
    updateActivity();

    // Add event listeners to reset timer
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Periodically check for inactivity
    const interval = setInterval(checkInactivity, 1000);

    // Listen for changes in activity from other tabs
    const handleStorageChange = (e) => {
      if (e.key === activityKey) {
        checkInactivity();
      }
    };
    window.addEventListener("storage", handleStorageChange);

    return () => {
      clearInterval(interval);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      window.removeEventListener("storage", handleStorageChange);
    };
     /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return <>{children}</>;
};

export default InactivityHandler;
